import { render, staticRenderFns } from "./dialogs.vue?vue&type=template&id=1fbd9bb9&scoped=true"
import script from "./dialogs.vue?vue&type=script&lang=js"
export * from "./dialogs.vue?vue&type=script&lang=js"
import style0 from "./dialogs.vue?vue&type=style&index=0&id=1fbd9bb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbd9bb9",
  null
  
)

export default component.exports